import { OrderBy, SortBy } from '../enums/sorting';

export class GiftCardFilter {
  query?: string | null;
  ids?: string[] | null;
  groupId?: string | null;
  enabled?: boolean | null;
  sort?: SortBy | null;
  order?: OrderBy | null;
  start?: number | null;
  limit?: number | null;

  constructor(init?: Partial<GiftCardFilter>) {
    Object.assign(this, init);
  }

  getQuery(): string {
    let q = '';
    q += this.query ? '&q=' + this.query : '';
    q += this.ids && this.ids.length > 0 ? '&id=' + this.ids.join(',') : '';
    q += this.groupId ? '&group_id=' + this.groupId : '';
    q += this.enabled ? '&enabled=' + this.enabled : '';
    q += this.sort ? '&sort=' + this.sort : '';
    q += this.order ? '&order=' + this.order : '';
    q += this.start ? '&start=' + this.start : '';
    q += this.limit ? '&limit=' + this.limit : '';
    q = q ? '?' + q.substring(1) : '';
    return q;
  }
}
